export enum DateFormat {
  date = 'DD/MM/YYYY',
  hours = 'h:mmA',
  queryFilterFormat = 'YYYY-MM-DD',
}
